module.exports = __webpack_public_path__ + "img/bmBg.ce277d59.jpg";